
import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
import { ConfigModule } from '@/store/modules/config'
import { CONFIGAPI } from '@/api/config'
import { getuserCurrentApp } from '@/utils/cookies'

@Component({
  name: 'editDialog',
  components: {}
})
export default class extends Vue {
  @Prop({ default: 'edit' }) private type!: string
  @Prop({ default: () => { return {} } }) private node!: any
  private isDisableSubmit: boolean = false
  private floorTags: any = [] // 楼层数组
  private inputVisible: boolean = false // 新建楼层按钮和input切换标识
  private addFloorVal: string = '' // 新建楼层名称
  private formData = {
    id: 0,
    place: 0,
    name: '',
    floors: []
  }
  private rules = {
    name: [
      { required: true, message: '请输入基地名称', trigger: 'blur' },
    ],
    floors: [{ required: true, message: '至少创建一个楼层', trigger: 'change' }]
  }

  get userCurrentApp() {
    return getuserCurrentApp()
  }

  get dialogVisible() {
    return ConfigModule.buildAddDialog
  }

  @Watch('dialogVisible')
  private initForm() {
    if (this.dialogVisible) { // 打开弹框
      if (this.type === 'add' && this.node) {
        this.formData = {
          id: 0,
          place: Number(this.$route.params.id),
          name: '',
          floors: []
        }
      } else if (this.type === 'edit') {
        this.formData = JSON.parse(JSON.stringify(Object.assign({}, this.node)))
      }
    }
  }

  // 删除楼层
  handleDelFloor(index: number) {
    this.formData.floors.splice((this.formData.floors as any).indexOf(index), 1)
  }
  // 展示添加楼层input
  showAddInput() {
    this.inputVisible = true;
    this.$nextTick(() => {
      (this.$refs.saveTagInput as any).$refs.input.focus()
    })
  }
  // 添加楼层
  handleAddFloor() {
    let inputValue = this.addFloorVal
    if (inputValue) {
      (this.formData.floors as any).push({ name: inputValue })
    }
    this.inputVisible = false
    this.addFloorVal = ''
  }

  // 提交按钮触发
  private handleSubmit(formName: string): void {
    (this.$refs[formName] as any).validate((valid: any) => {
      if (valid) {
        this.isDisableSubmit = true
        if (this.type === 'add') {
          this.addRequest()
        } else {
          this.editRequest()
        }
      } else {
        return false
      }
    })
  }

  // 新建保存
  private addRequest() {
    CONFIGAPI.addBuilding({
      place: this.formData.place,
      name: this.formData.name,
      floors: this.formData.floors
    }, {
      app_id: this.userCurrentApp
    }).then((res) => {
      if (res.stat === 1) {
        this.$message.success(res.data)
        ConfigModule.ToggleDialogStatus({
          name: 'buildAddDialog',
          value: false
        })
        this.$emit('handleSuccess')
      }
      this.isDisableSubmit = false
    }).catch((error) => {
      console.log('发生错误！', error)
      this.isDisableSubmit = false
    })
  }

  // 编辑保存
  private editRequest() {
    CONFIGAPI.editBuilding({
      name: this.formData.name,
      id: this.formData.id,
      floors: this.formData.floors
    }, {
      app_id: this.userCurrentApp
    }).then((res) => {
      if (res.stat === 1) {
        this.$message.success(res.data)
        ConfigModule.ToggleDialogStatus({
          name: 'buildAddDialog',
          value: false
        })
        this.$emit('handleSuccess')
      }
      this.isDisableSubmit = false
    }).catch((error) => {
      console.log('发生错误！', error)
      this.isDisableSubmit = false
    })
  }

  // 关闭弹框
  private handleClose() {
    ConfigModule.ToggleDialogStatus({
      name: 'buildAddDialog',
      value: false
    })
  }
}
